

















































































































































































































































































































import Vue from 'vue';
import { SweepEmailSourceModel, SweepEmailSourceConfigurationModel, GraphMailFolderModel } from '@/services/GeneratedApi';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { MTablehelper, confirmationHelper } from '@/mixins';
import { mapActions } from 'vuex';
import { ListModel, ListHeaderModel, ValueType, MStoreInputType, NotificationPresentationType } from '@/types';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  mixins: [MTablehelper, confirmationHelper],
  data() {
    return {
      mailFolders: [] as GraphMailFolderModel[],
      localEmailSource: { ...(this as any).emailSource } as SweepEmailSourceModel,
      isSubmitting: false,
      fileWhitelist: '' as string,
      graphCredentialsValid: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'Add',
      validator: (value: string) => ['Add', 'Edit'].includes(value)
    },
    emailSource: {
      type: Object as () => SweepEmailSourceModel,
      required: true
    },
    emailSourceConfigurationData: {
      type: Object as () => SweepEmailSourceConfigurationModel,
      required: true
    },
    emailSources: {
      type: Array as () => SweepEmailSourceModel[],
      required: true
    }
  },

  computed: {
    documentTypesForSelectedCabinet(this: any) {
      const cabinets = this.emailSourceConfigurationData.cabinets || [];
      const selectedCabinetId = this.localEmailSource.destinationCabinetId;
      const cabinet = cabinets.find((c: any) => c.id === selectedCabinetId);
      return cabinet && cabinet.documentTypes ? cabinet.documentTypes : [];
    },
    title(this: any): string {
      return this.mode === 'Add' ? 'Add Microsoft Graph Email Source' : 'Edit Microsoft Graph Email Source';
    },
    emailPluginsOptions(this: any): ListModel {
      return this.emailSourceConfigurationData.emailPlugins.length > 0
        ? {
            id: 0,
            key: 'id',
            text: 'id',
            headers: this.PLUGIN_LIST_FIELDS as ListHeaderModel[],
            list: this.emailSourceConfigurationData.emailPlugins,
            totalRow: this.emailSourceConfigurationData.emailPlugins.length,
            resultType: 1,
            listDataResultTypeMessage: ''
          }
        : ({} as ListModel);
    },
    signatureMaxFileSizeValidation(this: any) {
      if (this.localEmailSource.signatureFilterEnabled) {
        return {
          required: true,
          minValue: this.VALIDATION_RULES.signatureMaxFileSizeMinimum,
          maxValue: this.VALIDATION_RULES.signatureMaxFileSizeMaximum,
          valueType: ValueType.Integer
        } as ValidationModel;
      }
      return {
        required: false,
        valueType: ValueType.Integer
      } as ValidationModel;
    },
    signatureMaxDimensionValidation(this: any) {
      if (this.localEmailSource.signatureFilterEnabled) {
        return {
          required: true,
          minValue: this.VALIDATION_RULES.signatureMaxDimensionMinimum,
          maxValue: this.VALIDATION_RULES.signatureMaxDimensionMaximum,
          valueType: ValueType.Integer
        } as ValidationModel;
      }
      return {
        required: false,
        valueType: ValueType.Integer
      } as ValidationModel;
    },
    inboxIdsUsedByOtherSourcesOnSameMailbox(this: any): string[] {
      const currentMailbox = (this.localEmailSource.mailboxAddress || '').trim().toLowerCase();
      if (!currentMailbox) {
        return [];
      }
      return this.emailSources
        .filter((s: any) => s.id !== this.localEmailSource.id)
        .filter((s: any) => (s.mailboxAddress || '').trim().toLowerCase() === currentMailbox)
        .map((s: any) => s.sourceInboxId)
        .filter(Boolean);
    },
    inboxFolderValidation(this: any) {
      const otherFolders = [this.localEmailSource.archiveFolderId, this.localEmailSource.failedFolderId].filter(Boolean);
      return ({
        required: true,
        maxLength: 512,
        unique: { list: otherFolders, message: 'Inbox folder must be different to the Archive and Failed folders.' }
      } as unknown) as ValidationModel;
    },
    archiveFolderValidation(this: any) {
      const otherFolders = [this.localEmailSource.sourceInboxId, this.localEmailSource.failedFolderId].filter(Boolean);
      return ({
        required: true,
        maxLength: 512,
        unique: { list: otherFolders, message: 'Archive folder must be different to the Inbox and Failed folders.' }
      } as unknown) as ValidationModel;
    },
    failedFolderValidation(this: any) {
      const otherFolders = [this.localEmailSource.sourceInboxId, this.localEmailSource.archiveFolderId].filter(Boolean);
      return ({
        required: true,
        maxLength: 512,
        unique: { list: otherFolders, message: 'Failed folder must be different to the Inbox and Archive folders.' }
      } as unknown) as ValidationModel;
    },
    mailboxInputType(this: any) {
      return MStoreInputType.Email;
    },
    mailFoldersExcludingInboxesFromOtherSources(this: any): GraphMailFolderModel[] {
      const usedInboxIds = this.inboxIdsUsedByOtherSourcesOnSameMailbox;
      return this.mailFolders.filter((f: any) => !usedInboxIds.includes(f.id));
    }
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    initModalState(this: any) {
      this.isSubmitting = false;
      this.mailFolders = [];
      this.graphCredentialsValid = false;
      if (this.mode === 'Edit' && this.localEmailSource.graphCredentialId && this.localEmailSource.mailboxAddress) {
        this.getGraphMailFoldersAsync();
      }
      this.fileWhitelist = (this.emailSourceConfigurationData.fileWhitelist || []).join(', ');
    },
    async onSourceInboxChanged(this: any, selectedId: string) {
      this.sourceInboxId = selectedId;
      const selected = this.mailFolders.find((f: any) => f.id === selectedId);
      this.localEmailSource.sourceInboxDisplayName = selected ? selected.displayName : '';
    },

    onArchiveFolderChanged(this: any, selectedId: string) {
      this.archiveFolderId = selectedId;
      const selected = this.mailFolders.find((f: any) => f.id === selectedId);
      this.localEmailSource.archiveFolderName = selected ? selected.displayName : '';
    },

    onFailedFolderChanged(this: any, selectedId: string) {
      this.failedFolderId = selectedId;
      const selected = this.mailFolders.find((f: any) => f.id === selectedId);
      this.localEmailSource.failedFolderName = selected ? selected.displayName : '';
    },
    async getGraphMailFoldersAsync(this: any) {
      try {
        this.isLoading = true;
        this.mailFolders = await ApiConfiguration.apiWithoutNotification().sweepEmailSourceConfiguration.sweepEmailSourceConfigurationInboxesDetail({
          id: this.localEmailSource.graphCredentialId!,
          mailbox: this.localEmailSource.mailboxAddress
        });
        this.graphCredentialsValid = true;
      } catch (error) {
        this.$log(error);
        this.graphCredentialsValid = false;
      } finally {
        this.isLoading = false;
      }
    },
    onModalHidden(this: any) {
      this.$emit('modal-cancelled');
    },

    onModalShow() {
      this.localEmailSource = Object.assign({}, this.emailSource);
      this.initModalState();
    },
    async onSubmitAsync(this: any) {
      this.isSubmitting = true;
      this.setApplicationDirty(false);
      try {
        if (this.mode === 'Add') {
          await ApiConfiguration.api().sweepEmailSourceConfiguration.sweepEmailSourceConfigurationCreate(this.localEmailSource);
        } else {
          await ApiConfiguration.api().sweepEmailSourceConfiguration.sweepEmailSourceConfigurationUpdate(this.localEmailSource);
        }
        this.$emit('modal-saved');
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async onCancelClicked(this: any, dirty: boolean) {
      if (dirty) {
        const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, true);
        if (hasUnsavedChangesToKeep) {
          return;
        }
      }
      this.setApplicationDirty(false);
      this.$emit('modal-cancelled');
    },
    async onGraphCredentialChanged(this: any, invalid: boolean) {
      if (invalid) {
        return;
      }
      this.clearFolderSelection();
      if (this.localEmailSource.graphCredentialId && this.localEmailSource.mailboxAddress) {
        await this.getGraphMailFoldersAsync();
      }
    },
    async onMailboxAddressBlur(this: any, invalid: boolean) {
      if (invalid) {
        return;
      }
      this.clearFolderSelection();
      if (this.localEmailSource.graphCredentialId && this.localEmailSource.mailboxAddress) {
        await this.getGraphMailFoldersAsync();
      }
    },
    clearFolderSelection(this: any) {
      this.mailFolders = [];
      this.localEmailSource.sourceInboxId = '';
      this.localEmailSource.sourceInboxDisplayName = '';
      this.localEmailSource.archiveFolderId = '';
      this.localEmailSource.archiveFolderName = '';
      this.localEmailSource.failedFolderId = '';
      this.localEmailSource.failedFolderName = '';
    }
  },

  components: {
    MStoreForm: () => import('@/components/shared/MStoreForm.vue'),
    MStoreFormInput: () => import('@/components/shared/MStoreFormInput.vue'),
    MStoreFormCheckbox: () => import('@/components/shared/MStoreFormCheckbox.vue'),
    MStoreFormSelect: () => import('@/components/shared/MStoreFormSelect.vue'),
    MStoreFormSelectTable: () => import('@/components/shared/MStoreFormSelectTable.vue')
  },
  created(this: any) {
    this.PLUGIN_LIST_FIELDS = [
      {
        id: '',
        data: 'displayName',
        title: 'Display Name',
        key: 'displayName',
        label: 'Display Name'
      }
    ];
    this.VALIDATION_RULES = {
      signatureMaxFileSizeMinimum: 1024,
      signatureMaxFileSizeMaximum: 1024 * 1024,
      signatureMaxDimensionMinimum: 50,
      signatureMaxDimensionMaximum: 1000
    };
  }
});
